import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default function(id, options = {}) {
	return {
		id: id,

		init() {
			const swiper_container = this.$el.querySelector('.swiper');
			const pagination = this.$el.querySelector('.swiper-pagination');
			const nextButton = this.$el.querySelector('.swiper-button-next');
			const prevButton = this.$el.querySelector('.swiper-button-prev');

			const defaultOptions = {
				modules: [Navigation, Pagination],
				slidesPerView: 1,
				loop: true,
			};
			let mergedOptions = {...defaultOptions, ...options};

			if (pagination) {
				mergedOptions.pagination = {
					el: pagination,
					clickable: true,
				}
			}
			if (nextButton) {
				mergedOptions.navigation = {
					nextEl: nextButton,
					prevEl: prevButton,
				}
			}

			const slider = new Swiper(swiper_container, mergedOptions);
		}
	}
}
